define('services/layout',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // class
    'src/event-aggregator',
    // events
    'services/events/resize-events'

], function(
    // Libs
    _, Backbone, Mustache, U,
    // class
    EventAggregator,
    // events
    ResizeEvents
) {

    var openState = ['open', 'full'];
    var LayoutState = Backbone.Model.extend({

        defaults: {
            'info': null,
            'info.drawer': null,
            'menu': null,
            'menu.drawer': null,
        },

        initialize: function(options) {
            this.listenTo(this, {
                'change': this.resize,
                'change:info.drawer': this.onInfoDrawerChange
            });
        },

        resize: function(model, options) {
            ResizeEvents.resize();
        },

        isOpen: function(panelKey) {
            return openState.indexOf(this.get(panelKey)) > -1;
        },
        isFull: function(panelKey) {
            return this.get(panelKey) === "full";
        },

        setState: function(key, value, options) {
            return this.set(key, value ? 'open' : null, options);
        },

        setInfoState: function(open, full, options) {
            var changes = { info: full ? 'full' : open ? 'open' : null };
            if (!changes.info) changes['info.drawer'] = null;
            return this.set(changes, options);
        },

        ///////////
        // alias //
        ///////////

        toggleInfo: function(open, full) {
            this.trigger('toggle:info', open, full);
        },

        toggleInfoOverlay: function(val) {
            this.trigger('toggle:info:overlay', val);
        },
        //
        // toggleInfoFull: function(full) {
        //     this.trigger('toggle:full:info', full);
        // },
        //
        setInfo: function(view, options) {
            this.trigger('view:info', view, options);
        },
        //
        // toggleInfoDrawer: function(val) {
        //     this.trigger('toggle:info.drawer', val);
        // },
        //
        // setInfoDrawer: function(view, open) {
        //     this.trigger('view:info.drawer', view, open);
        // },

        toggleMenu: function(val) {
            this.trigger('toggle:menu', val);
        },
        //
        // toggleMenuDrawer: function(val) {
        //     this.trigger('toggle:menu.drawer', val);
        // },
        //
        // setMenuDrawer: function(view, open) {
        //     this.trigger('view:menu.drawer', view, open);
        // },

        stackInfo: function(view, open) {
            this.trigger('stack:info', view, open);
        },

        ////////////
        // events //
        ////////////

        onInfoDrawerChange: function(model, value, options) {
            if (value) this.setInfoState(null, true);
        }
    });

    var instance = new LayoutState();

    return instance;

});

